import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
import { GAEventAction, GAEventCategory, trackGoogleEvent } from 'util/google-helpers';
import { style } from './style';

interface Props {
  cmsData: any;
  isWindowClosed?: boolean;
}

export const Footer: FC<Props> = ({ cmsData, isWindowClosed = false }) => {
  const styles = style();
  const { links, copyright_text } = cmsData;

  const handleClick = (label: string) => {
    trackGoogleEvent(GAEventCategory.SITE, GAEventAction.CLICK, label);
  };

  const getFooterLinks = () => {
    const visibleLinks = !isWindowClosed
      ? links
      : links.filter((link: any) => {
          const isFAQLink = /faq/.test(link.text.toLowerCase());
          return !isFAQLink; // Don't include FAQ Link when window is closed
        });

    return visibleLinks.map((link: { text: string; url: string }, index: number) => {
      const isFAQLink = /faq/.test(link.text.toLowerCase());
      return (
        <li key={index}>
          <a
            onClick={() => handleClick(link.text)}
            href={link.url}
            target='_blank'
            rel='noopener noreferrer'
            className={css(styles.link, isFAQLink && styles.faqLink)}>
            {link.text}
          </a>
        </li>
      );
    });
  };

  return (
    <footer className={css(styles.footerContainer)}>
      <nav>
        <ul className={css(styles.footerLinksList)}>{getFooterLinks()}</ul>
      </nav>
      <div className={css(styles.copyright)} dangerouslySetInnerHTML={{ __html: copyright_text }}></div>
    </footer>
  );
};
